import React from 'react';
import { CheckCircle2, AlertCircle } from 'lucide-react';
const GLASS_ONLY = ['The window frame is still solid and operating properly', 'The glass is cracked, broken or shattered', 'A double-pane unit is foggy or has condensation between panes', 'The insulated glass seal has failed but the window frame is still usable', 'You want to upgrade to Low-E or insulated glass without replacing the whole window', 'You want a cost-effective repair before committing to full window replacement'];
const FULL_REPLACEMENT = ['The frame is rotted, warped or damaged', 'The window no longer opens, closes or locks correctly', 'Water is entering around the frame or wall', 'The sash or frame structure is failing', 'Multiple window components are damaged', 'You want to change the window size, style or full window system'];
export function Comparison() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1191">
      <div className="max-w-7xl mx-auto" data-id="element-1192">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-1193">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight" data-id="element-1194">
            Do You Need New Windows or Just New Glass?
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10" data-id="element-1195">
          <article className="bg-glassBlue-50 rounded-2xl p-8 border border-glassBlue-100 anim-on-scroll" data-id="element-1196">
            <h3 className="text-2xl font-bold text-navy-900 mb-6 flex items-center gap-3" data-id="element-1197">
              <CheckCircle2 className="w-8 h-8 text-brandBlue-600" aria-hidden="true" data-id="element-1198" />
              Glass-only replacement may be right when…
            </h3>
            <ul className="space-y-4" data-id="element-1199">
              {GLASS_ONLY.map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-1200">
                  <div className="w-2 h-2 rounded-full bg-brandBlue-500 mt-2.5 flex-shrink-0" aria-hidden="true" data-id="element-1201" />
                  <span className="text-slate-700 text-lg" data-id="element-1202">{bullet}</span>
                </li>)}
            </ul>
          </article>
          <article className="bg-slate-50 rounded-2xl p-8 border border-slate-200 anim-on-scroll" data-id="element-1203">
            <h3 className="text-2xl font-bold text-navy-900 mb-6 flex items-center gap-3" data-id="element-1204">
              <AlertCircle className="w-8 h-8 text-slate-500" aria-hidden="true" data-id="element-1205" />
              Full window replacement may be better when…
            </h3>
            <ul className="space-y-4" data-id="element-1206">
              {FULL_REPLACEMENT.map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-1207">
                  <div className="w-2 h-2 rounded-full bg-slate-400 mt-2.5 flex-shrink-0" aria-hidden="true" data-id="element-1208" />
                  <span className="text-slate-700 text-lg" data-id="element-1209">{bullet}</span>
                </li>)}
            </ul>
          </article>
        </div>
        <div className="max-w-3xl mx-auto mb-10" data-id="element-1210">
          <div className="bg-brandBlue-50 border-l-4 border-brandBlue-600 rounded-r-xl p-5 text-slate-700" data-id="element-1211">
            Many homeowners call Kosin's Glass because they want honest guidance
            on whether they need new glass or full window replacement.
          </div>
        </div>
        <div className="max-w-3xl mx-auto text-center" data-id="element-1212">
          <p className="text-slate-600 mb-8 italic" data-id="element-1213">
            Kosin's Glass can inspect your window glass and explain whether
            repair, glass replacement or full window replacement makes the most
            sense.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 flex-wrap" data-id="element-1214">
            <a href="#estimate-form" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-1215">
              Ask About Glass-Only Replacement
            </a>
            <a href="/replacementwindows.html" className="inline-flex items-center justify-center text-navy-900 hover:text-brandBlue-600 font-semibold py-3 px-4 transition-colors underline-offset-4 hover:underline" data-id="element-1216">
              Glass vs Replacement Windows →
            </a>
            <a href="/windowglass.html" className="inline-flex items-center justify-center text-navy-900 hover:text-brandBlue-600 font-semibold py-3 px-4 transition-colors underline-offset-4 hover:underline" data-id="element-1217">
              Window Glass Details →
            </a>
          </div>
        </div>
      </div>
    </section>;
}